import Axios from './axios';
import Mappings from './api.mappings';
export class SystemManageApi {
    listBizRuleLog(params) {
        return Axios.get(Mappings.systemManage.listBizRuleLog, { params });
    }
    getBizRuleLogDetail(id) {
        const params = {
            id
        };
        return Axios.get(Mappings.systemManage.getBizRuleLogDetail, { params });
    }
}
